import { ApplianceModel } from '../models/services/api/applianceLookup';

export const findApplianceFromResults = <T extends ApplianceModel>(
  modelNumber: string,
  models: T[],
) => {
  const match =
    models.find((model) => model.modelNumber.toLowerCase() === modelNumber.toLowerCase()) ||
    models.find((model) => modelNumber.toLowerCase().includes(model.modelNumber.toLowerCase())) ||
    models.find((model) => model.modelNumber.toLowerCase().includes(modelNumber.toLowerCase()));

  if (match) {
    if (Math.abs(match.modelNumber.length - modelNumber.length) <= 3) {
      return match;
    }
  }

  return undefined;
};
